import { MaterialStatus } from '../enum/Material';
import { EProjectType } from '../enum/project';
import { IFCustomFile, IFormikBOM, IFormikBOMUpdate } from '../pages/BackofficeMaterial/IBackofficeMaterial';
import { IMacra2TemplateRequestSerialized, IMaterialRequest, IMaterialRequestSerialized, ITemplateRequest, IMacra2TemplateRequest, ITemplateRequestSerialized } from './IApiRequest';
import { IMaterialResponse } from './IApiResponse';

export const serializeTemplateRequest = (template: ITemplateRequest): ITemplateRequestSerialized => {
    return {
        id: template.id,
        image: template.image,
        imageUrl: template.imageUrl,
        creationDate: template.creationDate,
        isDeleted: template.isDeleted,
        infos: JSON.stringify(template.infos),
        sectors: JSON.stringify(template.sectors),
        hydraulicData: JSON.stringify(template.hydraulicData)
    };
};

export const serializeMaterialRequestCreate = (material: IFormikBOM): FormData => {
    let formData = new FormData();
    material.images.forEach((data, index) => {
        if (!!data.actualFile) formData.append(`images[${index}]`, data.actualFile);
    });

    formData.append(
        'material',
        JSON.stringify({
            ...material,
            status: material.status ? MaterialStatus.Public : MaterialStatus.Test,
            images: [],
            type: parseInt(material.type as any),
            physicalData: [{ allowShearStress: material.allowShearStress, roughness: material.roughness }],
        }),
    );

    return formData;
};

export const serializeMaterialRequestUpdate = (formikData: IFormikBOMUpdate, material: IMaterialResponse): FormData => {
    let formData = new FormData();
    let oldImg: any = [];
    formikData.images.forEach((data, index) => {
        if (!!data.actualFile) formData.append(`images[${index}]`, data.actualFile);
        else {
            oldImg.push(data);
        }
    });

    formData.append(
        'material',
        JSON.stringify({
            ...material,
            status: formikData.status ? MaterialStatus.Public : MaterialStatus.Test,
            images: oldImg,
            type: parseInt(formikData.type as any),
            id: material.id,
            baseMaterialId: material.baseMaterialId,
            usage: formikData.usage,
            name: material.name,
            description: material.description,
            category: parseInt(formikData.category as any),
            creationDate: material.creationDate,
            updateDate: new Date(),
            producer: material.producer,
            isDeleted: material.isDeleted,
            color: formikData.color,
            isGeotextileFilter: formikData.isGeotextileFilter,
            isCastoro: formikData.isCastoro,
            isVegetated: formikData.isVegetated,
            isUnvegetatedWithBioTextile: !formikData.isVegetated,
            isXties: formikData.isXties,
            isAllowedChangeCheckbox: formikData.isAllowedChangeCheckbox,
            physicalData: formikData.physicalData,
            infos: formikData.infos,
            isAvailableStilling: formikData.isAvailableStilling,
            isAvailableSoil: formikData.isAvailableSoil
        }),
    );
    return formData;
};
export const serializeTemplateMacra2Request = (template: IMacra2TemplateRequest, isAdd: boolean = false): IMacra2TemplateRequestSerialized => {
    let newWeirGeometryTableLayer =
        (template.type as EProjectType) === (EProjectType.Macra2 | EProjectType.VerticalDrop)
            ? template.geometry.weirGeometryTableLayer.map(table => ({ ...table, id: isAdd ? undefined : table.id }))
            : [];

    return {
        id: isAdd ? undefined : template.id,
        image: template.image,
        creationDate: template.creationDate,
        infos: JSON.stringify(template.infos.map(info => ({ ...info, id: undefined }))),
        soilData: JSON.stringify({ ...template.soilData, id: isAdd ? undefined : template.soilData?.id }),
        geometry: JSON.stringify({ ...template.geometry, weirGeometryTableLayer: newWeirGeometryTableLayer, id: isAdd ? undefined : template.geometry.id }),
        hydraulicData: JSON.stringify({...template.hydraulicData, id: isAdd ? undefined : template.hydraulicData?.id }),
        type: template.type,
        imageUrl: template.image ? '' : template.imageUrl,
    };
};
